import { loadLs, saveLs } from '../../../storage/localStorage';
import { setInfoForDriverOrderData } from '../orderData';

const refs = {
  inputMessageToDriver: document.getElementById('driver-message'),
  confirmPaymentCheckbox: document.getElementById('confirm-payment'),
};
const { inputMessageToDriver, confirmPaymentCheckbox } = refs;

const KEY_LS = 'info-for-driver';

const initialInfoForDriver = {
  messageToDriver: '',
  confirmedPayment: false,
};

let infoForDriver = { ...initialInfoForDriver };

export const resetInfoForDriver = () => {
  infoForDriver = { ...initialInfoForDriver };
  saveLs(KEY_LS, infoForDriver);
  setInfoForDriverOrderData(infoForDriver);
  if (inputMessageToDriver) inputMessageToDriver.value = '';
  if (confirmPaymentCheckbox) confirmPaymentCheckbox.checked = false;
};

// =====================================
// Обробник вводу коментаря для водія
// =====================================
export const setInfoForDriver = data => {
  Object.assign(infoForDriver, data);
  saveLs(KEY_LS, infoForDriver);
  setInfoForDriverOrderData(infoForDriver);
};

// =====================================
// Відновлення даних з localStorage
// =====================================
const infoForDriverLS = loadLs(KEY_LS);
if (infoForDriverLS) {
  infoForDriver = infoForDriverLS;
  Object.entries(infoForDriverLS).forEach(([name, value]) => {
    if (name === 'messageToDriver' && value !== '') {
      if (inputMessageToDriver) inputMessageToDriver.value = value;
    }
    if (name === 'confirmedPayment') {
      if (confirmPaymentCheckbox) confirmPaymentCheckbox.checked = value;
    }
  });
  setInfoForDriverOrderData(infoForDriver);
}

// =====================================
// Слухач input (коментар для водія)
// =====================================
if (inputMessageToDriver) {
  inputMessageToDriver.addEventListener('input', event => {
    const message = event.target.value.trim();
    setInfoForDriver({ messageToDriver: message });
  });
}

// =====================================
// Слухач checkbox (підтвердження оплати)
// =====================================
if (confirmPaymentCheckbox) {
  confirmPaymentCheckbox.addEventListener('change', event => {
    const isChecked = event.target.checked;
    setInfoForDriver({ confirmedPayment: isChecked });
  });
}
